<template>
  <div id="features">
    <div id="steps-container" class="row">
      <step :title="$t('general.consulting')" textPath="stage-guide.consultingDescription" :img="imgConsulting" />
      <step :title="$t('general.adaption')" textPath="stage-guide.adaptionDescription" :img="imgCustomizing" />
      <step :title="$t('general.visualization')" textPath="stage-guide.visualizationDescription" :img="imgDisplay" />
      <step :title="$t('general.protection')" textPath="stage-guide.protectionDescription" :img="imgCustomizing" />
    </div>

    <hr class="divider" />
    <featurette-item id="featurette-1" :title="$t('stage-guide.featurette1Headline')" textPath="stage-guide.featurette1Description" :copyright="'© Messe Berlin GmbH'" :img="imgSccon" />
    <hr class="divider" />
    <featurette-item id="featurette-2" :title="$t('stage-guide.featurette2Headline')" textPath="stage-guide.featurette2Description" :copyright="'© Messe Berlin GmbH'" :img="imgDmea" :imgLeft="true" />
    <hr class="divider" />
    <featurette-item id="featurette-3" :title="$t('stage-guide.featurette3Headline')" textPath="stage-guide.featurette3Description" :img="imgSponsors" imgBackgroundSize="contain" />
    <hr class="divider" />
    <featurette-item id="featurette-4" :title="$t('stage-guide.featurette4Headline')" textPath="stage-guide.featurette4Description" :img="imgJobs" :imgLeft="true" :copyright="'© Messe Berlin GmbH'" />
    <hr class="divider" />
    <featurette-item id="featurette-5" :title="$t('stage-guide.featurette5Headline')" textPath="stage-guide.featurette5Description" :img="imgInfluencer" />
  </div>
</template>

<script>
import FeaturetteItem from "@/components/general/FeaturetteItem";
import Step from "@/components/general/Step";

import imgConsulting from "@/assets/img/steps-customizing.webp";
import imgCustomizing from "@/assets/img/steps-customizing.webp";
import imgDisplay from "@/assets/img/steps-display.webp";

import imgSccon from "@/assets/img/sccon19-2.webp";
import imgDmea from "@/assets/img/dmea-stage-tp.webp";
import imgDemoSessions from "@/assets/img/screenshot-demo-sessions.webp";
import imgSponsors from "@/assets/img/featurette-sponsors.webp";
import imgJobs from "@/assets/img/jobwall_sccon.webp";
import imgInfluencer from "@/assets/img/arrows-2023448_720.webp";

export default {
  computed: {
    imgConsulting() {
      return imgConsulting;
    },
    imgCustomizing() {
      return imgCustomizing;
    },
    imgDisplay() {
      return imgDisplay;
    },
    imgSccon() {
      return imgSccon;
    },
    imgDemoSessions() {
      return imgDemoSessions;
    },
    imgSponsors() {
      return imgSponsors;
    },
    imgJobs() {
      return imgJobs;
    },
    imgInfluencer() {
      return imgInfluencer;
    },
    imgDmea() {
      return imgDmea;
    }
  },

  components: {
    FeaturetteItem,
    Step
  }
};
</script>
